<template>
  <div class="wrapper">
    <div class="home-content-tab">
      <div id="scroll">
        <van-pull-refresh v-model="isLoading" @refresh="refresh">
          <div class="userBox">
            <div class="userLeft">
              <img :src="info.head_pic" />
              <div class="storeInfo">
                <div class="storeName">
                  <span>{{info.nick_name}}</span>
                  <span>的店铺</span>
                </div>
                <span class="desc">欢迎来到我的店铺</span>
              </div>
            </div>
            <div class="userRight" @click="share">
              <img src="../../assets/images/source/sourceShare.png" />
              <span>分享店铺</span>
            </div>
          </div>
          <img class="banner" v-if="banner" :src="banner" alt="">
          <div class="titleBox">
            <div :class="{title:true,active:activeTab=='0'}" @click="changeTab('0')">
              <img src="../../assets/images/source/sourceBanner.png" />
              <p>平价有机 健康生活</p>
              <div class="line"></div>
            </div>
            <div :class="{title:true,active:activeTab=='1'}" @click="changeTab('1')">
              <img src="../../assets/images/source/sourceBanner2.png" />
              <p>每天14:30开播,满10元配送</p>
              <div class="line"></div>
            </div>
          </div>

          <div style="display: flex;flex-direction: column;align-items: center;width: 100%;">
            <van-list class="activeTabWrap" v-model="loading" :finished="finished" @load="loadMore" :offset="20">
              <sourceItem v-for="(item,index) in goods_list" :key="index" :item='item' :roleText="roleText">
              </sourceItem>
            </van-list>
          </div>

          <div v-if="areaList.length > 0">
            <van-list v-model="areaLoading" :finished="areaFinished" @load="getAreaData" :immediate-check="false"
              :offset="20">
              <div class="area">
                <img class="areaTopImg" :src="areaImage" alt="">
                <div class="tabbox">
                  <div class="tabboxm" v-for="(commodity,cIndex) in areaList" :key="cIndex"
                    @click="golistdetail(commodity.nbr, commodity.rule_type)">
                    <div class="tabboxmt">
                      <img class="img" v-lazy="commodity.commodity_logo + `${imgCrop}resize,w_500`" alt="">
                      <div :class="commodity.quantity==='0'?'noNum':'noNum hide'">
                        <img v-lazy="require('../../assets/images/noNum.png')" alt="">
                      </div>
                      <!-- <img class="sales" v-if="commodity.start_state==0" src="../../assets/images/beSale.png" alt=""> -->
                    </div>
                    <div class="border"></div>
                    <div class="tanboxmm1 sigle-twoh">
                      {{commodity.commodity_name}}
                    </div>
                    <p class="commoditySummary sigle-h">{{commodity.commodity_summary}}</p>
                    <div class="tanboxmb">
                      <span class="bold"><i>￥</i>{{roleText=='sell'&&commodity.show_price?parseFloat(commodity.show_price):parseFloat(commodity[`min_${roleText}_price`])}}<span
                          v-if="Math.round((commodity[`min_sell_price`] - commodity[`min_${roleText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((commodity[`min_sell_price`] - commodity[`min_${roleText.toLowerCase()}_price`])*100)/100}}--></span>
                      </span>
                      <div class="priceRight">
                        <span class="priceSale" v-if="commodity.is_sales_show=='1'">已抢{{commodity.show_sales_num}}份</span>
                        <span class="priceSale" v-else></span>
                        <span class="tanboxmbspan">原价:{{parseFloat(commodity.old_price)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </van-pull-refresh>

      </div>
    </div>

    <!-- 分享按钮 -->
    <div class="poBtnArea">
      <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
        <img src="../../assets/images/index/top.svg" />
      </div>
    </div>

    <!-- 分享图 -->
    <div class="box">
      <van-popup v-model="shareShow">
        <div>
          <img :src="htmlUrl" alt="" class="swiper-showImg">
        </div>
      </van-popup>
      <div class="hold" v-if="shareShow">
        <div @click="wechatShareBtn1">
          <img src="../../assets/images/Sharing_Friends.png" /><br />
          <span>分享好友</span>
        </div>
        <div @click="wechatShareBtn2">
          <img src="../../assets/images/Sharing_Friends2.png" /><br />
          <span>分享朋友圈</span>
        </div>
        <div @click="downloadImg">
          <img src="../../assets/images/Save_pictures.png" /><br />
          <a :dowanload="htmlUrl">下载图片</a>
        </div>
      </div>
    </div>

    <div v-if="showHome" class="homeBtn" @click.stop="toHome">
      <span>回首页</span>
    </div>
  </div>
</template>

<script>
  import sourceItem from "./sourceItem";
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {
      sourceItem: sourceItem,
    },
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        activeTab: '0',
        nbr: "105", // 专区nbr
        goods_list: [], //商品
        loading: false, //上拉加载
        finished: false, //加载完成
        canAdd: false,
        pageIndex: 0,
        numPerPage: 10,
        roleText: "sell",
        keepAlive: true,
        isLoading: false,
        scroll: 0,
        title: "",
        toTopShow: false,
        sortType: "0",
        sortOrder: "1",
        isLogin: 0,
        option: {},
        shareShow: false,
        htmlUrl: '',
        info: {},
        banner: '',
        qrCode: '',
        showHome: false,

        areaLoading: false,
        areaFinished: false,
        areaIndex: 0,
        areaList:[],
      };
    },
    watch: {
      $route(to, from) {
        if (
          from.path == "/information" ||
          from.path == "/placeorder" ||
          from.path == "/index"
        ) {
          this.keepAlive = true;
        } else {
          this.keepAlive = false;
        }
      }
    },
    computed: {
    },
    methods: {
      golistdetail(nbr, rule_type) {
        if(rule_type=='2'){
          this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
        }else{
          this.$router.push({ path: "/listdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
        }
        
      },
      toHome() {
        this.$router.replace({
          path: "/index",
        });
      },
      share() {
        if (this.htmlUrl) {
          this.shareShow = true
        } else if (this.qrCode) {
          this.shareImage()
        } else {
          this.createCode();
          this.codeTimer = setInterval(() => {
            this.createCode();
          }, 5000);
        }
      },
      shareImage() {
        let that = this
        let toast = that.$toast.loading({ message: '生成分享图' })
        that.$post("/api/image/share/generateTianXinHomeShareImage", {
          codeUrl: that.qrCode,
          username: that.info.nick_name,
          userHeadUrl: that.info.head_pic,
        }).then(res => {
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              that.htmlUrl = resp.imageUrl;
              that.shareShow = true
            }
          }
          toast.clear()
        }).catch(err => {
          toast.clear()
        });
      },
      createCode() {
        let that = this;
        let toast = that.$toast.loading({ message: '生成二维码' })
        that.$post("/api/wechat/gzh/generateNewQRCode", {
          page: '/sourceList',
          supNbr: this.userInfo.nbr,
        }).then(res => {
          let resp = res.object.resp;
          if (res.code == "200") {
            if (resp.resp_code == "0" && resp.resp_result == "0") {
              that.qrCode = resp.qrcode;
              clearInterval(that.codeTimer);
              that.shareImage()
            }
          }
          toast.clear()
        }).catch(err => {
          toast.clear()
        });
      },
      // 下载提示
      downloadImg() {
        this.$toast({
          message: '请长按保存图片',
          duration: 2000
        });
      },
      // 分享朋友
      wechatShareBtn1() {
        this.$toast({
          message: '请点击右上角进行分享',
          duration: 2000
        });
      },
      // 分享朋友圈
      wechatShareBtn2() {
        this.$toast({
          message: '请点击右上角进行分享',
          duration: 2000
        });
      },
      checkOption() {
        if (!(this.userInfo && this.userInfo.nbr)) {
          this.isLogin = 0;
          this.roleText = 'sell';
        } else {
          this.isLogin = 1;
          this.getUserInfo();
        }
        this.option.title && this.goods_list.length > 0 && this.weChatShare(this.option);
      },
      refresh() {
        this.finished = true;
        this.pageIndex = 0;
        this.getData([]);
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },
      loadMore() {
        if (this.finished) {
          return false;
        }
        if (this.canAdd) {
          this.loading = true;
          this.pageIndex++;
          this.getData(this.goods_list);
        }
      },
      getShareInfo() {
        let that = this
        // this.goods_list = oldList;
        this.$commonPost({
          jydm: "flow_70013",
          flow_70013: {
            area_nbr: '105',
            sort_type: this.sortType,
            sort_order: this.sortOrder,
            page_index: 0,
            num_per_page: 1,
            parent_nbr: "",
            type: -1
          }
        })
          .then(response => {
            that.option = {
              title: response.share_title || response.area_title,
              desc: response.share_desc || '',
              link: `${location.origin}/sourceList?supNbr=${this.userInfo.nbr}`,
              images: response.share_image || response.image_path,
            }
            setTimeout(() => {
              that.weChatShare(that.option);
            }, 500)
            this.title = response.area_title;
            this.banner = response.image_path || ''
            document.title = response.area_title;
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      changeTab(index) {
        if (this.activeTab == index) return false
        this.activeTab = index
        this.nbr = index == '0' ? '105' : '106'
        this.pageIndex = 0
        this.finished = false
        this.getData([])
      },
      getData(oldList) {
        let that = this
        // this.goods_list = oldList;
        this.$commonPost({
          jydm: "flow_70013",
          flow_70013: {
            area_nbr: this.nbr,
            sort_type: this.sortType,
            sort_order: this.sortOrder,
            page_index: this.pageIndex * this.numPerPage,
            num_per_page: this.numPerPage,
            parent_nbr: "",
            type: -1
          }
        })
          .then(response => {
            let arr = [];
            if (response.commodity) {
              if (response.commodity.length > 0) {
                arr = response.commodity;
              } else {
                arr.push(response.commodity);
              }
            }
            arr.map((item, index) => {
              let arr = []
              if (item.commodity_label) {
                arr = item.commodity_label.split(' ')
                arr = arr.filter((label) => { return label })
              }
              item.labelArr = arr
            })

            this.goods_list = oldList.concat(arr);
            this.canAdd = arr.length >= this.numPerPage;
            this.loading = false;
            if (arr.length < this.numPerPage) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      getAreaData() {
        this.areaLoading = true
        this.$commonPost({
          jydm: "flow_70013",
          flow_70013: {
            area_nbr: '107',
            page_index: this.areaIndex * this.numPerPage,
            num_per_page: this.numPerPage,
            type: "-1"
          }
        })
          .then(response => {
            let arr = [];
            if (response.commodity) {
              if (response.commodity.length > 0) {
                arr = response.commodity;
              } else {
                arr.push(response.commodity);
              }
            }
            this.areaImage= response.image_path
            this.areaList = this.areaList.concat(arr);
            this.areaIndex = this.areaIndex + 1
            this.areaLoading = false
            if (arr.length < this.numPerPage) {
              this.areaFinished = true
            } else {
              this.areaFinished = false
            }
          })
          .catch(err => {
            this.areaLoading = false
            if (arr.length < this.numPerPage) {
              this.areaFinished = true
            } else {
              this.areaFinished = false
            }
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
      handleScroll() {
        // 设备/屏幕高度
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 50) {
          this.toTopShow = true;
        } else {
          this.toTopShow = false;
        }
      },
      // 回到顶部动画
      toTopAnimate() {
        window.scrollTo(0, 0);
      },
      getUserInfo() {
        // 用户的基本信息(身份)
        this.$commonPost({
          jydm: "flow_10003",
          flow_10003: {
            user_nbr: this.userInfo.nbr
          }
        })
          .then(response => {
            this.info = response;
            if (response.new_role == 0 || response.new_role == 1) {
              this.roleText = "sell";
            } else if (response.new_role == 2) {
              this.roleText = "agent";
            } else if (response.new_role == 3) {
              this.roleText = "director";
            }
          })
          .catch(err => {
            this.$toast({
              message: err.message,
              duration: 2000
            });
          });
      },
    },
    created() {
    },
    mounted() {
    },
    // 被缓存时任执行
    activated() {
      window.addEventListener('scroll', this.handleScroll, true);
      window.scrollTo(0, this.scroll);
      document.title = this.title;
      if (!this.keepAlive) {
        //将高度滚动到原来离开页面的高度
        document.getElementById("scroll").scrollTop = this.scroll;
        return false;
      } else {
        let that = this;
        this.activeTab = '0'
        this.nbr = '105'
        this.pageIndex = 0;
        this.qrCode = '';
        this.htmlUrl = '';
        this.goods_list = [];
        this.getShareInfo()
        this.getData([]);

        this.pageIndex = 0;
        this.areaList = [];
        this.getAreaData()
      }
      this.checkOption();
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (from.path == '/login') {
          vm.showHome = true
        } else {
          vm.showHome = false
        }
      });
    },
    beforeRouteLeave(to, from, next) {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      window.removeEventListener('scroll', this.handleScroll, true);
      next();
    }
  };
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
  .box .van-popup {
    background: none;
    top: 38%;

    img {
      width: 65vw;
      height: 115.7vw;
      object-fit: cover;
      background: #ccc;
    }
  }

  .hold {
    width: 100%;
    height: 2.48rem;
    background: #FFFFFF;
    border-top-left-radius: .1rem;
    border-top-right-radius: .1rem;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999999;
    display: flex;
  }

  .hold div {
    width: 2.5rem;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .hold img {
    width: 1.2rem;
    height: 1.2rem;
    margin-top: 0.33rem;
    margin-bottom: 0.2rem;
  }

  .poBtnArea {
    position: fixed;
    right: .24rem;
    z-index: 999;
    bottom: 2rem;
    text-align: right;
  }

  .toTop {
    width: .8rem;
    height: 0.8rem;
    margin-top: .3rem;
    background: rgba(51, 51, 51, 0.5);
    text-align: center;
    line-height: .8rem;
    border-radius: 50%;
    display: inline-block;
  }

  .toTop img {
    width: 0.4rem;
    height: 0.4rem;
  }

  .wrapper {
    width: 100%;
    min-height: 100vh;
    background: #f5f5f5;
  }

  .activeTabWrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .userBox {
    width: 100%;
    height: 1.4rem;
    box-sizing: border-box;
    padding: 0 .2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-image: linear-gradient(1deg, #FFFFFF 0%, #DBFBDA 100%);

    .userLeft {
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 1rem;
        height: 1rem;
        border-radius: .5rem;
        margin-right: .14rem;
      }

      .storeInfo {
        display: flex;
        flex-direction: column;

        .storeName {
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            line-height: .33rem;
            font-size: .24rem;
            color: #333;
          }

          span:first-child {
            max-width: 3.12rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        .desc {
          margin-top: .04rem;
          line-height: .34rem;
          font-size: .22rem;
          color: #999;
        }
      }

    }

    .userRight {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: .4rem;
        height: .4rem;
      }

      span {
        line-height: .3rem;
        font-size: .22rem;
        color: #333;

        &:last-child {
          color: #999;
        }
      }
    }
  }

  .banner {
    width: 100%;
    height: 4.02rem;
    object-fit: cover;
  }

  .titleBox {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: .2rem;
  }

  .title {
    flex: 1;
    height: 1.63rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 1.78rem;
      height: .45rem;
    }

    p {
      line-height: .4rem;
      margin-top: .1rem;
      font-size: .28rem;
      color: #999;
    }

    .line {
      width: .5rem;
      height: .08rem;
      background: #BCBCBC;

    }
  }

  .title.active {
    background: #fff;

    .line {
      background: #09C35D;
    }
  }

  .homeBtn {
    position: fixed;
    left: .24rem;
    bottom: 2rem;
    z-index: 999;
    width: .8rem;
    height: .8rem;
    border-radius: .4rem;
    box-sizing: border-box;
    background: rgba(51, 51, 51, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-size: .24rem;
      color: #fff;
    }
  }

  .area {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .areaTopImg {
      width: 7.02rem;
      height: 2.4rem;
      border-radius: .16rem;
      margin: 0 auto;
      object-fit: cover;
    }

    .tabbox {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    .sigle-twoh {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .tabboxm {
      margin-top: 0.24rem;
      width: 3.42rem;
      height: 5.8rem;
      background: #fff;
      border-radius: 0.16rem;
      overflow: hidden;
      border: 1px solid #dddddd;
      position: relative;
    }

    .border {
      width: 3.26rem;
      height: 1px;
      background: #ddd;
      margin: 0 auto;
    }

    .tabboxm:nth-of-type(2n) {
      margin-left: 0.18rem;
    }

    .tabboxm:nth-of-type(2n - 1) {
      margin-left: 0.24rem;
    }

    .tabboxmt {
      position: relative;
    }

    .tabboxm .noNum {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      background: rgba(51, 51, 51, 0.3);
      width: 100%;
      height: 3.43rem;
    }

    .tabboxm .noNum img {
      width: 3rem;
      height: 2.3rem;
    }

    .tabboxmt .img {
      width: 3.42rem;
      height: 3.43rem;
      object-fit: cover;
    }

    .tabboxmt .sales {
      width: 1.16rem;
      height: 0.3rem;
      position: absolute;
      bottom: -0.15rem;
      left: 0.1rem;
      z-index: 9;
    }

    .tanboxmm1 {
      width: 3.22rem;
      line-height: 0.34rem;
      height: 0.68rem;
      margin: 0 0.1rem;
      font-size: 0.24rem;
      margin-top: 0.12rem;
      color: #333333;
      word-break: break-all;
    }

    .tanboxmm2 {
      line-height: 0.32rem;
      margin: 0 0.24rem;
      margin-top: 0.15rem;
      font-size: 0.22rem;
      color: #999;
    }

    .tanboxmb {
      margin-top: 0.26rem;
      width: 100%;
      height: .65rem;
      box-sizing: border-box;
      padding: 0 .1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      line-height: 0.33rem;
      overflow: hidden;
    }

    .tanboxmb .bold {
      color: #FE0000;
      font-size: 0.46rem;
      font-weight: bold;
    }

    .tanboxmb .bold i:nth-of-type(1) {
      font-size: 0.24rem;
      color: #FE0000;
    }

    .priceRight{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .priceSale{
      height: .33rem;
      line-height: .33rem;
      font-size: 0.24rem;
      color: #333;
    }

    .tanboxmbspan {
      font-size: 0.24rem;
      text-decoration: line-through;
      color: #d2d2d2;
      line-height: .33rem;
    }
    .hide {
      display: none !important;
    }

    .nomore {
      text-align: center;
      color: #999999;
      line-height: 30px;
      margin-top: 0.1rem;
    }
  }

  .commoditySummary {
    width: 3.22rem;
    font-size: .22rem;
    color: #EF842C;
    margin-top: 0.14rem;
    font-weight: 400;
    height: .32rem;
    line-height: .32rem;
    margin-left: .1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
</style>
<style lang="stylus" scoped>
  .home-content-tab>>>.van-pull-refresh {
    padding-bottom: .2rem;
    box-sizing: border-box;
    min-height: 100vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/sourceList.vue